import React, { useContext } from 'react'
import { MicroFrontend } from '@praxis/component-microfrontend'
import { envConfigs } from '../apiConfig'
import { UserContext } from '../App/UserContext'
import { MFEProps } from './MFEProps'
import type { ComponentType } from 'react'
import type { WorkspaceViewTabsProps } from 'workspaces/components/WorkspaceViewTabs'
import ErrorPage from 'layout/ErrorPage'
import LoadingPage from 'layout/LoadingPage'

interface ContainerComponentsContract {
  PLMWorkspaceTabs: WorkspaceViewTabsProps
}

type ContainerComponentsMap = {
  [Key in keyof ContainerComponentsContract]?: ComponentType<
    ContainerComponentsContract[Key]
  >
}

type SparkMFEProps = MFEProps & {
  route?: string
  componentsFromContainer?: ContainerComponentsMap
}

const SparkMFE = ({
  environment,
  route,
  componentsFromContainer,
}: SparkMFEProps) => {
  const { sparkUser } = useContext(UserContext)

  return (
    <MicroFrontend
      module="./SparkMFE"
      src={envConfigs[environment].spark.mfeSrc}
      environment={environment}
      user={sparkUser}
      route={route}
      componentsFromContainer={componentsFromContainer}
      Error={ErrorPage}
      Loading={LoadingPage}
    />
  )
}

export default SparkMFE
